import { alpha } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '0px 8px',
  },
  agent: {
    padding: '30px',
  },
  agent_header: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'flex-end',
  },
  agent_table: {
    marginTop: '20px',
    '& table': {
      tableLayout: 'fixed',
      width: '100%',
    },
  },
  agent_create_button: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 14px',
    gap: '6px',
    height: '40px',
    background: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '140%',
  },
  agent_table_row: {
    cursor: 'pointer',
  },
  agent_table_row_new: {
    animation:
      '$newAgentRowEnter 550ms cubic-bezier(0.2, 0.75, 0.3, 1), $newAgentRowHighlight 2.2s ease-out 250ms',
  },
  agent_table_row_deleting: {
    pointerEvents: 'none',
    animation: '$agentRowExit 260ms ease-in forwards',
  },
  '@keyframes newAgentRowEnter': {
    '0%': {
      opacity: 0,
      transform: 'translateY(8px) scale(0.99)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0) scale(1)',
    },
  },
  '@keyframes newAgentRowHighlight': {
    '0%': {
      backgroundColor: alpha(theme.palette.primary.main, 0.18),
    },
    '35%': {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
    '100%': {
      backgroundColor: 'transparent',
    },
  },
  '@keyframes agentRowExit': {
    '0%': {
      opacity: 1,
      transform: 'translateY(0) scale(1)',
      backgroundColor: alpha(theme.palette.error.main, 0.06),
    },
    '100%': {
      opacity: 0,
      transform: 'translateY(-6px) scale(0.985)',
      backgroundColor: alpha(theme.palette.error.main, 0.18),
    },
  },
  agent_table_first_cell: {
    // display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: '7px',
    fontWeight: 'bold !important',
  },
  agent_table_sort_cell: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  agent_table_popover: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px',
  },
  agent_table_popover_button: {
    gap: '11px',
    justifyContent: 'start',
    borderRadius: '4px',
  },
  nameCell: {
    minWidth: '160px',
    width: '160px',
    maxWidth: '160px',
  },
  sexCell: {
    minWidth: '85px',
    width: '85px',
    maxWidth: '85px',
    overflow: 'hidden',
  },
  voiceCell: {
    minWidth: '180px',
    width: '180px',
    maxWidth: '180px',
    position: 'relative',
    overflow: 'hidden',
  },
  llmCell: {
    minWidth: '140px',
    width: '140px',
    maxWidth: '140px',
  },
  transcriberCell: {
    minWidth: '130px',
    width: '130px',
    maxWidth: '130px',
  },
  languageCell: {
    minWidth: '120px',
    width: '120px',
    maxWidth: '120px',
  },
  profileCell: {
    minWidth: '150px',
    width: '150px',
    maxWidth: '150px',
  },
  agentIdCell: {
    minWidth: '70px',
    width: '70px',
    maxWidth: '70px',
    overflow: 'hidden',
  },
  agentIdContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  agentIdCopyButton: {
    justifyContent: 'center',
  },
  startCell: {
    minWidth: '80px',
    width: '80px',
    maxWidth: '80px',
  },
  startButton: {
    width: 30,
    height: 30,
    border: '1px solid',
    borderColor: theme.palette.extendedGrey?.lighter,
    borderRadius: theme.shape.borderRadius,
    '& path, & rect': {
      fill: theme.palette.primary.main,
    },
    '&:hover': {
      backgroundColor: theme.palette.extendedGrey?.lightest,
      '& path, & rect': {
        fill: theme.palette.primary.contrastText,
      },
    },
  },
  actionsCell: {
    minWidth: '112px',
    width: '112px',
    maxWidth: '112px',
  },
  genderIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  maleIcon: {
    fontSize: 22,
    color: theme.palette.info.main,
  },
  femaleIcon: {
    fontSize: 22,
    color: theme.palette.chart[9],
  },
  voiceIconWithName: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  volumeUpIcon: {
    fontSize: 18,
    flexShrink: 0,
  },
  volumeOffIcon: {
    fontSize: 18,
    flexShrink: 0,
  },
  voiceNameText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  campaign: {
    padding: '30px',
  },
  campaign_header: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'space-between',
  },
  campaign_header_title: {
    display: 'flex',
    alignItems: 'center',
    placeItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
  },
  campaign_table: {
    marginTop: '20px',
  },
  campaign_table_row: {
    cursor: 'pointer',
  },
  campaign_table_first_cell: {
    paddingLeft: '0px',
  },
  campagin_table_sort_cell: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 3,
  },
  campagin_table_th: {
    flexBasis: 'min-content',
    textWrap: 'nowrap',
    fontSize: 11,
    fontWeight: 600,
  },
  requiredMarker: {
    color: theme.palette.error.main,
    marginLeft: 2,
  },
  subtitle: {
    fontSize: 18,
  },
  agent_table_th_advanced_settings: {
    display: 'flex',
    padding: '6px',
    justifyContent: 'flex-end',
  },
}));
